import {
  Component,
  Input,
  ViewChild,
  forwardRef,
  ElementRef,
  AfterViewInit
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { inputType, ControlBase } from "../config";

@Component({
  selector: "ixs-Currencytextbox",
  templateUrl: "ixscurrencytextbox.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IXSCurrencyTextBoxComponent),
      multi: true
    },
    {
      provide: ControlBase,
      useExisting: IXSCurrencyTextBoxComponent
    }
  ]
})
export class IXSCurrencyTextBoxComponent extends ControlBase
  implements ControlValueAccessor, AfterViewInit {

  ngAfterViewInit(): void {
  }

  @ViewChild("input") ixsTextBox: ElementRef;
  constructor() {
    super()
  }

  private innerValue = "";

  private onTouchedCallback: () => void;
  private onChangeCallback: (_: any) => void;

  get value() {
    return this.innerValue;
  }

  @Input()
  set value(v: any) {
    
    if (v !== this.innerValue) {
      this.formatCurrency(v.toString(), '');
      this.innerValue = v;
      this.onChangeCallback(v);
    }
    this.onChangeCallback(v);

  }

  onBlur() {
    this.onTouchedCallback();
  }


  writeValue(value: any) {
    
    if (value !== this.innerValue) {
      if (value) {
        value = value.toString();
        this.formatCurrency(value, 'blur');
        this.innerValue;
      }
      else {
        this.innerValue = ""
      }
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  @Input()
  caption: string;

  @Input()
  disabled: boolean = false;

  @Input()
  showCaption: boolean = true;

  @Input()
  placeholder: string = "";

  @Input()
  maxlength: number;

  @Input()
  minlength: number;

  @Input()
  position: number = 1;

  private _fieldWidth = "input-group col-lg-3 col-md-3 col-sm-9 col-xs-9";

  @Input()
  get fieldWidth(): string {
    return this._fieldWidth;
  }
  set fieldWidth(value: string) {

    if (value && value.indexOf(",") !== -1) {
      let colSplit = value.split(",");

      if (colSplit && colSplit.length === 4) {
        this._fieldWidth =
          "input-group col-lg-" +
          (colSplit[0] ? colSplit[0] : "3") +
          " col-md-" +
          (colSplit[1] ? colSplit[1] : "3") +
          " col-sm-" +
          (colSplit[2] ? colSplit[2] : "3") +
          " col-xs-" +
          (colSplit[3] ? colSplit[3] : "3");
      }
    }
  }

  private _captionWidth = "col-lg-1 col-md-1 col-sm-3 col-xs-3 col-form-label";

  @Input()
  get captionWidth(): string {
    return this._captionWidth;
  }
  set captionWidth(value: string) {
    if (value && value.indexOf(",") !== -1) {
      let colSplit = value.split(",");

      if (colSplit && colSplit.length === 4) {
        this._captionWidth =
          "col-lg-" +
          (colSplit[0] ? colSplit[0] : "1") +
          " col-md-" +
          (colSplit[1] ? colSplit[1] : "1") +
          " col-sm-" +
          (colSplit[2] ? colSplit[2] : "3") +
          " col-xs-" +
          (colSplit[3] ? colSplit[3] : "3") +
          "col-form-label";
      }
    }
  }

  // change(event) {
  //   this.formatCurrency(event, 'blur')
  // }

  Keyup(event) {
    
    this.formatCurrency(event, '')
  }

  blur(event) {
    
    this.formatCurrency(event, "blur")
  }

  formatCurrency(event, blur) {
    
    var input_val = event;

    if (input_val === "") {
      return;
    }
    if (input_val.indexOf(".") >= 0) {
      
      var decimal_pos = input_val.indexOf(".");
      var left_side = input_val.substring(0, decimal_pos);
      var right_side = input_val.substring(decimal_pos);

      left_side = this.formatNumber(left_side);
      right_side = this.formatNumber(right_side);

      right_side = right_side.substring(0, 2);
      input_val = left_side + "." + right_side;
      
    }

    else {
      input_val = this.formatNumber(input_val);

      if (blur === "blur") {
        input_val += ".00";
      }
    }
    this.innerValue = input_val;
  }

  formatNumber(n) {
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  focus(event) {
    event.srcElement.select();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/ixscurrencytextbox/ixscurrencytextbox.component.ts